export function getSearchParam(param) {
  const searchParams = window.location.search;

  if (searchParams.includes(param)) {
    return searchParams.split(`${param}=`)[1].split("&")[0];
  }

  return "";
}
